export default function offerSchemaBrand (buy, offer, type = offer.type) {
    if (buy) {
        return (offer.makes || []).join(' - ') || ''
    } else {
        switch (type) {
            case 'car_ad':
            case 'truck_ad':
            case 'motorcycle_ad':
            case 'agri_ad':
            case 'budowlane':
            case 'przyczepy':
                return offer.make
            case 'part_ad':
                return offer.part_producer || ''
            case 'service':
            case 'tool_ad':
                return offer.title || ''
            default:
                return ''
        }
    }
}